import React from 'react';
import { CardContent, Stack } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import TemplateInformationSection from './sections/TemplateInformationSection';
import ScheduleConfigurationSection from './sections/ScheduleConfigurationSection';
import AssignmentSection from './sections/AssignmentSection';
import LifecycleSection from './sections/LifecycleSection';
import { HstAccessSection } from '../../../tickets/components/TicketForm/sections/HstAccessSection';
import { CpsiAccessSection } from '../../../tickets/components/TicketForm/sections/CpsiAccessSection';
import { PMDetailsSection } from '../../../tickets/components/TicketForm/sections/PMDetailsSection';
import { RecurringTaskGeneralTicketTemplateSection } from './sections/RecurringTaskGeneralTicketTemplateSection';

/**
 * RecurringTaskCreateForm - Main form container for recurring task creation
 * Shows conditional sections based on category selection (matching ticket behavior)
 */
export const RecurringTaskCreateForm: React.FC = () => {
  const currentRecurringTask = useAppSelector(state => state.recurringTask.currentRecurringTask);
  
  // Determine which access request section to show based on category
  const showGeneralTicketTemplateSection = currentRecurringTask?.category === 'GEN';
  const showHstAccessSection = currentRecurringTask?.category === 'HST';
  const showCpsiAccessSection = currentRecurringTask?.category === 'CPSI';
  const showPMSection = currentRecurringTask?.category === 'PM';
  
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <form autoComplete="off">
        <Stack spacing={2.5}>
          <TemplateInformationSection />
          
          {/* Conditional Template/Access Request Sections based on category */}
          {showGeneralTicketTemplateSection && <RecurringTaskGeneralTicketTemplateSection />}
          {showHstAccessSection && <HstAccessSection mode="recurringTask" />}
          {showCpsiAccessSection && <CpsiAccessSection mode="recurringTask" />}
          {showPMSection && <PMDetailsSection mode="recurringTask" showFindings={false} showPartsUsed={false} />}
          
          <ScheduleConfigurationSection />
          <AssignmentSection />
          <LifecycleSection />
        </Stack>
      </form>
    </CardContent>
  );
};

export default RecurringTaskCreateForm;
